import { Box, Typography } from '@mui/material';
import Lottie from 'lottie-react';
import TreeAnimation from '../../../../utils/Lottie/Tree.json';

const GRADIENTS = {
  Birthday:
    'linear-gradient(119.49deg, rgba(255,255,255,0.5) 0%, rgba(216,247,255,0.6) 36.87%, rgb(223,255,223) 98.31%)',
  Anniversary:
    'linear-gradient(134.28deg, rgba(255,255,255,0.5) 0%, rgba(255,216,228,0.6) 36.865%, rgb(223,230,255) 98.306%)',
};

const TreeLottieCard = ({ occasion = 'Birthday', onComplete }) => (
  <Box
    sx={{
      background: GRADIENTS[occasion] || GRADIENTS.Birthday,
      borderRadius: '16px',
      p: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1,
    }}
  >
    <Lottie
      animationData={TreeAnimation}
      loop={false}
      onComplete={onComplete}
      style={{ width: 150, height: 150 }}
    />
    <Typography variant='h3' sx={{ color: '#333', textAlign: 'center' }}>
      Planting a tree for you!
    </Typography>
  </Box>
);

export default TreeLottieCard;
